import React from "react";

const CalenderNext = ({ _className, ...props }: any) => {
  return (
    <svg width={7} height={12} fill="none" {...props}>
      <path
        className={_className}
        fill="var(--color-icon-bright)"
        d="M6.2 6c0 .467-.18.933-.533 1.287L1.32 11.633a.503.503 0 0 1-.706 0 .503.503 0 0 1 0-.706L4.96 6.58a.82.82 0 0 0 0-1.16L.614 1.073a.503.503 0 0 1 0-.706.503.503 0 0 1 .706 0l4.347 4.346c.353.354.533.82.533 1.287Z"
      />
    </svg>
  );
};

export default CalenderNext;
